import UnderlinePlugin from '../../components/SlatePlugins/Underline';

const slateConfig = (config) => {
  // Inizializza le configurazioni di Slate se non esistono
  if (!config.settings.slate) {
    config.settings.slate = {};
  }
  
  // Plugins
  if (!config.settings.slate.plugins) {
    config.settings.slate.plugins = [];
  }
  config.settings.slate.plugins = [...config.settings.slate.plugins, UnderlinePlugin];
  
  // Integrazione con la toolbar esistente
  const slateSettings = config.settings.slate;
  
  // Aggiungi il pulsante alla toolbar principale se non c'è già
  if (!slateSettings.toolbarButtons) {
    slateSettings.toolbarButtons = [];
  }
  if (!slateSettings.toolbarButtons.includes('underline')) {
    const formattingIndex = slateSettings.toolbarButtons.findIndex(button => 
      button === 'bold' || button === 'italic');
    
    if (formattingIndex !== -1) {
      // Inserisci 'underline' dopo 'bold' e 'italic'
      slateSettings.toolbarButtons.splice(formattingIndex + 1, 0, 'underline');
    } else {
      // Se 'bold' o 'italic' non sono trovati, aggiungi alla fine
      slateSettings.toolbarButtons.push('underline');
    }
  }
  
  // Aggiungi il pulsante alla toolbar inline
  if (!slateSettings.inlineToolbarButtons) {
    slateSettings.inlineToolbarButtons = [];
  }
  if (!slateSettings.inlineToolbarButtons.includes('underline')) {
    slateSettings.inlineToolbarButtons.push('underline');
  }
  
  // Configura l'hotkey
  if (!slateSettings.hotkeys) {
    slateSettings.hotkeys = {};
  }
  slateSettings.hotkeys['mod+u'] = { format: 'underline' };
  
  return config;
};

export default slateConfig;